import { graphql, useStaticQuery } from 'gatsby';

const querySepBannerData = () => {
    const queryData: { featureFlags: { [key: string]: IFeatureFlag } } = useStaticQuery(graphql`
        query SepBannerData {
            featureFlags {
                ehim_SepBanner {
                    enable
                }
            }
        }
    `);
    return queryData.featureFlags.ehim_SepBanner.enable;
};

export default querySepBannerData;
